export const redirectToSanitizedHubSpotUrl = url => {
  const currentURL = new URL(window.location.href);
  const parsedUrl = new URL(decodeURIComponent(url));
  if (parsedUrl.origin !== currentURL.origin) {
    return;
  }
  parsedUrl.protocol = 'https';
  window.location.href = parsedUrl.toString();
};